import { createContext, useContext } from 'react';

/**
 * The nav tree the current view shows (useScopedNavLinks): the hub, admin, a game, its onboarding steps, a
 * portfolio... Provided by the shells that render the sidebar (DashboardLayout, Cheats). The sidebar renders it,
 * and the page header's section switcher and page icon resolve against it, so all three follow the view.
 *
 * Null outside those shells; consumers fall back to the static hub tree (navConfig).
 */
export const NavTreeContext = createContext(null);

export const useNavTree = () => useContext(NavTreeContext);
